<template>
  <div>
  <div>
    <v-card class="mb-5" >
      <v-card-title>
        <h5 v-if="!editTitle" class="primary--text">{{ about.title }}
            <v-btn small
                class="title-action"
                @click.prevent="editTitle = true" icon
                color="primary"
                v-if="$can('create actors')">
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
        </h5>
        <v-text-field
          name="title"
          v-else
          label="Titre"
          id="id"
          @keyup.enter.prevent="save"
          v-model="item.title"
        ></v-text-field>
      </v-card-title>

      <v-card-text >
        <div class="actions">
          <v-btn v-if="!editBody && $can('create actors')" small @click.prevent="editBody = true" icon color="primary"><v-icon>mdi-pencil</v-icon></v-btn>
          <v-btn v-if="editBody && $can('create actors')" small @click.prevent="save" color="primary" rounded><v-icon>mdi-check</v-icon>Enrégister</v-btn>
        </div>
      </v-card-text>
      <v-card-text >
        <div v-if="!editBody" class="content" v-html="about.text"></div>
        <v-layout row v-else wrap>
          <v-flex xs12 class="mt-5 mx-4">
            <tiptap-vuetify
              focus
              class="full-heigh"
              v-model="item.text"
              :extensions="extensions"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <v-card class="mb-5" >
      <v-card-title>
        <h5 class="primary--text">Les partenaires</h5>
      </v-card-title>

      <v-card-text >
        <v-container fluid grid-list-md >
          <v-layout row text-center>
            <v-flex fill-height mb-10>
              <img src="/img/pays_bas.png" alt="Pays bas logo" width="200" height="75">
            </v-flex>
          </v-layout>
          <v-layout row wrap align-center>
            <v-flex xs12 sm12 md12 >
              <img src="/img/ifdc.jpg" alt="logos partenaires" width="900" height="155">
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>

   </div>
  </div>
</template>
<script>
import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, CodeBlock, Paragraph, BulletList, OrderedList,
  ListItem, Link, Blockquote, HardBreak, HorizontalRule, History
} from 'tiptap-vuetify'
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Permissions from '~/mixins/Permissions';

export default {
  name: "about",
  mixins: [Permissions],
  components: {
    TiptapVuetify
  },

  data: () => ({
    loaded_type: false,
    editTitle: false,
    editBody: false,
    item: {
      title: '',
      text: ''
    },
    extensions: [
      // you can specify options for extension
      new Heading({
        levels: [1, 2, 3]
      }),
      new Bold(),
      new Italic(),
      new Strike(),
      new Underline(),
      new Code(),
      new CodeBlock(),
      new Paragraph(),
      new BulletList(),
      new OrderedList(),
      new ListItem(),
      new Link(),
      new Blockquote(),
      new HardBreak(),
      new HorizontalRule(),
      new History()
    ],
  }),
  created () {
    this.fetchAbout()
    this.fetchUtils();
    this.item =  this.about
  },
  watch: {
    item: {
      handler(newValue){

      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(['about']),
    domaines () { return this.$store.getters.domains; },
  },
  methods: {
    ...mapMutations(['SET_ABOUT']),
    ...mapActions([ 'fetchAbout', 'updateAbout']),
    fetchUtils () {
      this.$store.dispatch('fetchDomains');
    },
    save(){
      this.updateAbout(this.item)
      this.editBody = false
      this.editTitle = false
    }
  }

};
</script>

<style>
.v-application a {
    cursor: pointer;
    text-decoration: none;
}
.title-action{
  margin-left: 3rem;
}

.actions{
  z-index: 2000;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  right: 0;
}

.about-title{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* width: 50%; */
}

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/overview/about.vue